module.exports = __webpack_public_path__ + "img/drug-25.20631105.png";